import Vue from 'vue';
import Router from 'vue-router';
import { basePath } from '@/libs';
import Home from './views/Home.vue';
import store from './store';
import conf from './aws-configuration';

Vue.use(Router);

const { authurl } = conf;
const { clientid } = conf;
const { endpoint } = conf;

function hasExpired() {
    if (new Date(store.state.tokens.expiry) > new Date()) {
        return false;
    }
    return true;
}

export default new Router({
    mode: 'history',
    // base: process.env.BASE_URL,
    base: `${basePath}`,
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home,
        },
        {
            path: '/index.html',
            name: 'home2',
            component: Home,
        },
        {
            path: '/workflow',
            name: 'workflow',
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () => import('./views/Workflow.vue'),
            beforeEnter: (to, from, next) => {
                if (!store.state.loggedin || hasExpired()) {
                    next({ name: 'login' });
                }
                if (!store.state.isstudent && !store.state.issecondary) {
                    next();
                } else {
                    next('/');
                }
            },
        },
        {
            path: '/canvasworkflow',
            name: 'canvasworkflow',
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () => import('./views/CanvasWorkflow.vue'),
            beforeEnter: (to, from, next) => {
                if (!store.state.loggedin || hasExpired()) {
                    next({ name: 'login' });
                }
                if (!store.state.isstudent && !store.state.issecondary) {
                    next();
                } else {
                    next('/');
                }
            },
        },
        {
            path: '/airport',
            name: 'airport',
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () => import('./views/Airport.vue'),
            // only allow admins to see the admin page.
            beforeEnter: (to, from, next) => {
                if (!store.state.loggedin || hasExpired()) {
                    next({ name: 'login' });
                }
                if (store.state.isadmin) {
                    next();
                } else {
                    next('/');
                }
            },
        },
        {
            path: '/canvasairport',
            name: 'canvasairport',
            component: () => import('./views/CanvasAirport.vue'),
            beforeEnter: (to, from, next) => {
                if (!store.state.loggedin || hasExpired()) {
                    next({ name: 'login' });
                }
                if (store.state.isadmin) {
                    next();
                } else {
                    next('/');
                }
            },
        },
        {
            path: '/myrequests',
            name: 'myrequests',
            component: () => import('./views/MyRequests.vue'),
            beforeEnter: (to, from, next) => {
                if (!store.state.loggedin || hasExpired()) {
                    next({ name: 'login' });
                }
                if (!store.state.isstudent && !store.state.issecondary) {
                    next();
                } else {
                    next('/');
                }
            },
        },
        {
            path: '/canvasmyrequests',
            name: 'canvasmyrequests',
            component: () => import('./views/CanvasMyRequests.vue'),
            beforeEnter: (to, from, next) => {
                if (!store.state.loggedin || hasExpired()) {
                    next({ name: 'login' });
                }
                if (!store.state.isstudent && !store.state.issecondary) {
                    next();
                } else {
                    next('/');
                }
            },
        },
        {
            path: '/coursevis',
            name: 'coursevis',
            component: () => import('./components/workflowsteps/CourseVisibilityStep.vue'),
            beforeEnter: (to, from, next) => {
                if (!store.state.loggedin || hasExpired()) {
                    next({ name: 'login' });
                }
                if (!store.state.isstudent && !store.state.issecondary) {
                    next();
                } else {
                    next('/');
                }
            },
        },
        {
            path: '/authlanding',
            name: 'authlanding',
            component: () => import('./views/AuthLanding.vue'),
        },
        {
            path: '/login',
            name: 'login',
            beforeEnter: () => {
                // eslint-disable-next-line max-len
                window.location.href = `${authurl}/oauth2/authorize?redirect_uri=${endpoint}/authlanding&response_type=code&client_id=${clientid}&state=STATE&scope=profile%20email%20openid`;
            },
        },
        {
            path: '/logout',
            name: 'logout',
            beforeEnter: (to, from, next) => {
                store.commit('LOGOUT');
                next('/logoutlanding');
            },
        },
        {
            path: '/logoutlanding',
            name: 'logoutlanding',
            component: () => import('./views/LogOutLanding.vue'),
        },
    ],
});
